module.exports = __webpack_public_path__ + "img/3.661b8d22.png";